import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';

import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
  selector: 'app-block-wise-report',
  templateUrl: './block-wise-report.component.html',
  styleUrls: ['./block-wise-report.component.scss']
})
export class BlockWiseReportComponent implements OnInit, OnDestroy {
  blockWiseReportForm: FormGroup;
  sessionList: any[] = [];
  SessionFilterList: any[] = [];
  CollegeList: any[] = [];
  filteredCollegeList: any[] = [];
  CourseList: any[] = [];
  filteredCourseList: any[] = [];
  ExamAList: any[] = [];
  filteredExamAList: any[] = [];
  blocks: any[] = [];
  filteredBlocks: any[] = [];
  isDownloading: boolean = false;
  dialogRef: MatDialogRef<any>;
  isBranch: boolean = false;
  BranchList: any[] = [];
  filteredBranchList: any[] = [];
  subjectList: any[] = [];
  filteredSubjectList: any[] = [];
  subjectHeadList: any[] = [];
  filteredSubjectHeadList: any[] = [];
  allSubjectHeadsWithParent: any[] = [];
  private subjectChangeSub: any;
  private subjectsRequestId = 0;

  showDownloadButton: boolean = false;
  userPermission: any;
  userId: number | null = null;
  UserCollege: string = '';
  seatNumberList: any[] = [];

  studentList: any[] = [];
  isLoadingStudents: boolean = false;
  hasSearchedStudents: boolean = false;
  searchString: string = '';

  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20, 50];
  currentPage = 1;
  totalItems = 0;

  isFinalized: boolean = false;
  isFinalizing: boolean = false;

  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public router: Router,
    public fb: FormBuilder,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission") || '[]');
    this.userId = this.userPermission.length ? this.userPermission[0].UserId : null;
    this.UserCollege = this.userPermission[0]?.CgUi === 'C' ? this.userPermission[0].CgId : '';

    this.initializeForm();
    this.fetchSessions();
  }

  ngOnDestroy(): void {
    if (this.subjectChangeSub) {
      this.subjectChangeSub.unsubscribe();
    }
  }

  initializeForm(): void {
    this.blockWiseReportForm = this.fb.group({
      SessionId: new FormControl('', Validators.required),
      course: new FormControl('', Validators.required),
      college: new FormControl('', Validators.required),
      Exam: new FormControl('', Validators.required),
      Branch: new FormControl(''),
      SelectedSubject: new FormControl(null),
      SelectedSubjectHead: new FormControl(null),
      block: new FormControl(''),
      totalAbsent: new FormControl(0),
      totalCopyCase: new FormControl(0),
      absentSeats: this.fb.array([]),
      copyCaseSeats: this.fb.array([])
    });

    this.blockWiseReportForm.get('SessionId').valueChanges.subscribe(value => {
      if (value) {
        this.fetchCourses(value);
        this.resetDependentFields(['course', 'college', 'Exam', 'Branch', 'SelectedSubject', 'SelectedSubjectHead', 'block']);
        this.resetTotalsAndSeats();
        this.clearStudentGrid();
        this.isFinalized = false;
      }
    });

    this.blockWiseReportForm.get('course').valueChanges.subscribe(value => {
      if (value) {
        this.fetchCollegesForCourse();
        this.resetDependentFields(['college', 'Exam', 'Branch', 'SelectedSubject', 'SelectedSubjectHead', 'block']);
        this.resetTotalsAndSeats();
        this.clearStudentGrid();
        this.isFinalized = false;
      }
    });

    this.blockWiseReportForm.get('college').valueChanges.subscribe(value => {
      if (value) {
        this.fetchExamsForCourse();
        this.resetDependentFields(['Exam', 'Branch', 'SelectedSubject', 'SelectedSubjectHead', 'block']);
        this.resetTotalsAndSeats();
        this.clearStudentGrid();
        this.isFinalized = false;
      }
    });

    this.blockWiseReportForm.get('Exam').valueChanges.subscribe(value => {
      if (value) {
        this.checkIfBranchRequired(value);
        this.fetchSubjects(value);
        this.resetDependentFields(['Branch', 'SelectedSubject', 'SelectedSubjectHead', 'block']);
        this.resetTotalsAndSeats();
        this.clearStudentGrid();
        this.isFinalized = false;
      }
    });

    this.blockWiseReportForm.get('Branch').valueChanges.subscribe(value => {
      const examId = this.blockWiseReportForm.get('Exam').value;
      if (examId) {
        this.fetchSubjects(examId);
        this.resetTotalsAndSeats();
        this.clearStudentGrid();
        this.isFinalized = false;
      }
    });

    this.blockWiseReportForm.get('SelectedSubjectHead').valueChanges.subscribe(value => {
      this.blockWiseReportForm.get('block')?.setValue('', { emitEvent: false });
      this.resetTotalsAndSeats();
      this.clearStudentGrid();
      this.isFinalized = false;
    });

    this.blockWiseReportForm.get('totalAbsent').valueChanges.subscribe(count => {
      this.updateSeatArray(this.absentSeats, count);
    });

    this.blockWiseReportForm.get('totalCopyCase').valueChanges.subscribe(count => {
      this.updateSeatArray(this.copyCaseSeats, count);
    });

    this.blockWiseReportForm.valueChanges.subscribe(() => {
      this.updateDownloadButtonVisibility();
    });
  }

  get absentSeats(): FormArray {
    return this.blockWiseReportForm.get('absentSeats') as FormArray;
  }
  get copyCaseSeats(): FormArray {
    return this.blockWiseReportForm.get('copyCaseSeats') as FormArray;
  }
  get absentSeatControls(): FormControl[] {
    return this.absentSeats.controls as FormControl[];
  }
  get copyCaseSeatControls(): FormControl[] {
    return this.copyCaseSeats.controls as FormControl[];
  }

  get primarySubjectId(): number {
    const v = this.blockWiseReportForm?.value?.SelectedSubject;
    return v ? Number(v) : 0;
  }

  get primarySubjectHeadId(): number {
    const v = this.blockWiseReportForm?.value?.SelectedSubjectHead;
    return v ? Number(v) : 0;
  }

  get srNoStart(): number {
    return (this.currentPage - 1) * this.pageSize;
  }

  getStudentStatus(s: any): string {
    if (!s) return '';
    const raw =
      s.Status ??
      s.status ??
      s.AttStatus ??
      s.ExamStatus ??
      s.StatusCode ??
      s.EfStatus ??
      '';
    return (raw === null || raw === undefined) ? '' : String(raw).toUpperCase().trim();
  }

  getStudentStatusLabel(s: any): string {
    const code = this.getStudentStatus(s);
    if (code === 'P' || code === 'PRESENT') return 'Present';
    if (code === 'AB' || code === 'A' || code === 'ABSENT') return 'Absent';
    if (code === 'CC' || code === 'COPYCASE') return 'CopyCase';
    return code || '-';
  }

  getStudentStatusColor(s: any): string {
    const code = this.getStudentStatus(s);
    if (code === 'P' || code === 'PRESENT') return '#28a745';
    if (code === 'AB' || code === 'A' || code === 'ABSENT') return '#dc3545';
    if (code === 'CC' || code === 'COPYCASE') return '#fd7e14';
    if (!code) return '#e9ecef';
    return '#6c757d';
  }

  getStudentStatusTextColor(s: any): string {
    const code = this.getStudentStatus(s);
    return code ? '#fff' : '#6c757d';
  }

  private updateSeatArray(arr: FormArray, count: any): void {
    const n = Number(count) || 0;
    while (arr.length < n) {
      arr.push(new FormControl('', Validators.required));
    }
    while (arr.length > n) {
      arr.removeAt(arr.length - 1);
    }
  }

  private resetTotalsAndSeats(): void {
    this.blockWiseReportForm.get('totalAbsent')?.setValue(0, { emitEvent: false });
    this.blockWiseReportForm.get('totalCopyCase')?.setValue(0, { emitEvent: false });
    this.absentSeats.clear();
    this.copyCaseSeats.clear();
  }

  private clearStudentGrid(): void {
    this.studentList = [];
    this.seatNumberList = [];
    this.hasSearchedStudents = false;
    this.totalItems = 0;
    this.currentPage = 1;
    this.searchString = '';
    this.isFinalized = false;
  }

  seatValue(item: any): any {
    if (item === null || item === undefined) return item;
    return item.EfRollNo ?? item.RollNo ?? item;
  }

  seatLabel(item: any): string {
    if (item === null || item === undefined) return '';
    const roll = item.EfRollNo ?? item.RollNo ?? '';
    const name = item.StudentName ?? item.StuName ?? '';
    return name ? `${roll} - ${name}` : `${roll}`;
  }

  fetchStudents(resetPage: boolean = true): void {
    const formData = this.blockWiseReportForm.value;
    const subjectId = this.primarySubjectId;
    const headId = this.primarySubjectHeadId;

    if (!formData.SessionId || !formData.course || !formData.college ||
        !formData.Exam || !subjectId || !headId) {
      this.showError('Please select Session, Course, College, Exam, Subject and Subject Head.');
      return;
    }

    if (resetPage) {
      this.currentPage = 1;
    }

    const payload = {
      SnNo: formData.SessionId,
      CoCode: formData.course,
      Cent: formData.college,
      CgCode: '',
      EmId: formData.Exam,
      EsId: subjectId,
      SubEsId: headId,
      StrId: formData.Branch || 0,
      RollNo: 0,
      SearchString: this.searchString || '',
      PageSize: this.pageSize,
      PageNumber: this.currentPage
    };

    console.log('GetStuExamAttend payload:', payload);

    this.isLoadingStudents = true;
    this.spinner.show();

    this.umsService.getStuExamAttend(payload).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.isLoadingStudents = false;
        this.hasSearchedStudents = true;

        if (res && res.status && res.data && res.data.length > 0) {
          this.studentList = res.data;
          this.seatNumberList = res.data;
          this.totalItems = res.count != null ? res.count : res.data.length;

          this.isFinalized = this.studentList.some((r: any) => {
            const v = r.IsFinal ?? r.isFinal ?? '';
            return String(v).toUpperCase().trim() === 'Y';
          });

          console.log('First student row:', res.data[0]);
          console.log('isFinalized:', this.isFinalized);
        } else {
          this.studentList = [];
          this.seatNumberList = [];
          this.totalItems = 0;
          this.isFinalized = false;
          this.showError(res?.message || 'No Data Found');
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.isLoadingStudents = false;
        this.hasSearchedStudents = true;
        this.studentList = [];
        this.seatNumberList = [];
        this.totalItems = 0;
        this.isFinalized = false;

        if (error.status === 404) {
          this.showAlert('No Data Found');
        } else {
          this.showError('Error fetching student list.');
        }
      }
    );
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex + 1;
    this.fetchStudents(false);
  }

  onSearchChange(event: any): void {
    this.searchString = event?.target?.value || '';
  }

  onSearch(): void {
    this.fetchStudents(true);
  }

  checkIfBranchRequired(examId: number): void {
    const selectedExam = this.ExamAList.find(item => item.EmId === examId);
    this.isBranch = selectedExam?.EmStreams === 'Y';

    if (this.isBranch) {
      this.fetchBranches(examId);
    } else {
      this.BranchList = [];
      this.filteredBranchList = [];
      this.blockWiseReportForm.get('Branch').setValue('');
    }
  }

  fetchBranches(examId: number): void {
    this.spinner.show();
    const payload = { EmId: examId };

    this.umsService.getExamStream(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.BranchList = res.data;
        this.filteredBranchList = this.BranchList.slice();
        this.blockWiseReportForm.get('Branch').setValue('');
      } else {
        this.BranchList = [];
        this.filteredBranchList = [];
      }
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
      this.BranchList = [];
      this.filteredBranchList = [];
    });
  }
  fetchSubjects(examId: number): void {
    const reqId = ++this.subjectsRequestId;

    const branchId = this.blockWiseReportForm.get('Branch').value || 0;

    this.subjectList = [];
    this.filteredSubjectList = [];
    this.subjectHeadList = [];
    this.filteredSubjectHeadList = [];
    this.allSubjectHeadsWithParent = [];

    this.blockWiseReportForm.get('SelectedSubject')?.reset(null);
    this.blockWiseReportForm.get('SelectedSubjectHead')?.reset(null);

    this.spinner.show();

    const payload = {
      EsEmId: examId,
      EsStrId: branchId
    };

    this.umsService.getExamSubMapFetch(payload).subscribe((res) => {
      // Ignore stale response
      if (reqId !== this.subjectsRequestId) {
        return;
      }

      this.spinner.hide();

      if (res.status && res.data?.children?.length) {
        const subjectMap = new Map<number, any>();
        const allHeadsMap = new Map<number, any>();

        res.data.children.forEach((parent: any) => {
          if (parent.EsType === 'S') {
            // Standalone subject
            if (!subjectMap.has(parent.EsId)) {
              subjectMap.set(parent.EsId, {
                SubCode: parent.EsCode,
                SubName: parent.EsName,
                EsId: parent.EsId
              });
            }
            this.collectSubjectHeads(parent, allHeadsMap, parent.EsId);
          } else if (parent.EsType === 'G') {
            parent.children?.forEach((child: any) => {
              if (!subjectMap.has(child.EsId)) {
                subjectMap.set(child.EsId, {
                  SubCode: child.EsCode,
                  SubName: child.EsName,
                  EsId: child.EsId
                });
              }
              this.collectSubjectHeads(child, allHeadsMap, child.EsId);
            });
          }
        });

        this.subjectList = Array.from(subjectMap.values());
        this.allSubjectHeadsWithParent = Array.from(allHeadsMap.values());
        this.subjectHeadList = [...this.allSubjectHeadsWithParent];
        this.filteredSubjectHeadList = [...this.subjectHeadList];
        this.filteredSubjectList = [...this.subjectList];

        this.listenToSubjectChanges();
      } else {
        this.subjectList = [];
        this.filteredSubjectList = [];
        this.subjectHeadList = [];
        this.filteredSubjectHeadList = [];
        this.allSubjectHeadsWithParent = [];
      }
    }, (error: HttpErrorResponse) => {
      if (reqId !== this.subjectsRequestId) {
        return;
      }
      this.spinner.hide();
      this.subjectList = [];
      this.filteredSubjectList = [];
      this.subjectHeadList = [];
      this.filteredSubjectHeadList = [];
      this.allSubjectHeadsWithParent = [];
    });
  }

  collectSubjectHeads(node: any, map: Map<number, any>, owningSubjectId: number) {
    if (node.EsType === 'H' && Number(node.NotPrintAdmitCrd) === 0) {
      if (!map.has(node.EsId)) {
        map.set(node.EsId, {
          EsId: node.EsId,
          EsCode: node.EsCode,
          EsName: node.EsName,
          EsParent: node.EsParent,
          EsType: node.EsType,
          OwningSubjectId: owningSubjectId
        });
      }
    }
    if (node.children && node.children.length > 0) {
      node.children.forEach((child: any) => {
        this.collectSubjectHeads(child, map, owningSubjectId);
      });
    }
  }

  listenToSubjectChanges() {
    if (this.subjectChangeSub) {
      this.subjectChangeSub.unsubscribe();
    }
    this.subjectChangeSub = this.blockWiseReportForm.get('SelectedSubject')?.valueChanges.subscribe(
      (selectedSubjectId: any) => {
        if (selectedSubjectId === null || selectedSubjectId === undefined || selectedSubjectId === '') {
          this.subjectHeadList = [...this.allSubjectHeadsWithParent];
        } else {
          this.subjectHeadList = this.allSubjectHeadsWithParent.filter(
            h => Number(h.OwningSubjectId) === Number(selectedSubjectId)
          );
        }
        this.filteredSubjectHeadList = [...this.subjectHeadList];

        const currentHead = this.blockWiseReportForm.value.SelectedSubjectHead;
        if (currentHead !== null && currentHead !== undefined) {
          const stillValid = this.subjectHeadList.some(
            h => Number(h.EsId) === Number(currentHead)
          );
          if (!stillValid) {
            this.blockWiseReportForm.controls['SelectedSubjectHead'].setValue(null);
          }
        }
      }
    );
  }

  onSubjectHeadChange(event: any) { }

  getSubjectNameById(esId: any): string {
    if (!esId) return '';
    const found = this.subjectList.find(s => Number(s.EsId) === Number(esId));
    return found ? found.SubName : '';
  }

  getSubjectHeadNameById(esId: any): string {
    if (!esId) return '';
    const found = this.subjectHeadList.find(h => Number(h.EsId) === Number(esId));
    return found ? found.EsName : '';
  }

  fetchSessions(): void {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe((res) => {
      if (res.status) {
        this.sessionList = res.data.filter((item: any) => item.SnStatus === 'O');
        this.SessionFilterList = this.sessionList.slice();
      } else {
        this.sessionList = [];
        this.SessionFilterList = [];
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
      this.showError('Error fetching sessions');
    });
  }

  fetchCourses(sessionId: string): void {
    this.spinner.show();
    const payload = { SessionID: sessionId };

    this.umsService.getSessionColgCo(payload).subscribe((res) => {
      if (res.status) {
        const uniqueCourses = res.data.filter((course: any, index: number, self: any[]) =>
          index === self.findIndex((c: any) => c.CoCgCoCode === course.CoCgCoCode)
        );
        this.CourseList = uniqueCourses;
        this.filteredCourseList = this.CourseList.slice();
      } else {
        this.CourseList = [];
        this.filteredCourseList = [];
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
      this.showError('Error fetching courses');
    });
  }

  fetchCollegesForCourse(): void {
    const sessionId = this.blockWiseReportForm.get('SessionId').value;
    const courseCode = this.blockWiseReportForm.get('course').value;

    if (!sessionId || !courseCode) return;

    this.spinner.show();
    const payload = { SnNo: sessionId, CoCode: courseCode };

    this.umsService.getCollege(payload).subscribe((res) => {
      if (res.status) {
        let collegeData = res.data;
        if (this.UserCollege) {
          collegeData = collegeData.filter((college: any) => college.CgCode === this.UserCollege);
          if (collegeData.length === 1) {
            this.blockWiseReportForm.get('college').setValue(collegeData[0].CgCode);
          }
        }
        this.CollegeList = collegeData;
        this.filteredCollegeList = this.CollegeList.slice();
        if (!this.UserCollege || collegeData.length > 1) {
          this.blockWiseReportForm.get('college').setValue('');
        }
      } else {
        this.CollegeList = [];
        this.filteredCollegeList = [];
        this.blockWiseReportForm.get('college').setValue('');
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
      this.showError('Error fetching colleges');
    });
  }

  fetchExamsForCourse(): void {
    const courseCode = this.blockWiseReportForm.get('course').value;
    const sessionId = this.blockWiseReportForm.get('SessionId').value;

    if (!courseCode || !sessionId) return;

    this.spinner.show();
    const payload = { EmCoCode: courseCode, SnNo: sessionId };

    this.umsService.getExam(payload).subscribe((res) => {
      if (res.status) {
        this.ExamAList = res.data;
        this.filteredExamAList = this.ExamAList.slice();
        this.blockWiseReportForm.get('Exam').setValue('');
      } else {
        this.ExamAList = [];
        this.filteredExamAList = [];
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
      this.showError('Error fetching exams');
    });
  }

  // fetchBlocksForExam(): void {
  //   const examId = this.blockWiseReportForm.get('Exam').value;
  //   const selectedCollege = this.blockWiseReportForm.get('college').value;
    
  //   if (!examId || !selectedCollege) return;

  //   this.spinner.show();
    
  //   const payload = {
  //     EcId: examId,
  //     CgCode: selectedCollege
  //   };

  //   this.umsService.getCollegeWiseBlocks(payload).subscribe((res) => {
  //     if (res.status && res.data && res.data.length > 0) {
  //       this.blocks = res.data;
  //       this.filteredBlocks = this.blocks.slice();
        
  //       this.blockWiseReportForm.get('block').setValue('');
  //     } else {
  //       this.blocks = [];
  //       this.filteredBlocks = [];
  //       this.blockWiseReportForm.get('block').setValue('');
  //       this.showAlert('No blocks found for the selected exam and college.');
  //     }
  //     this.spinner.hide();
  //   }, (error: HttpErrorResponse) => {
  //     this.spinner.hide();
  //     this.blocks = [];
  //     this.filteredBlocks = [];
  //     this.blockWiseReportForm.get('block').setValue('');
  //     this.showAlert('Error fetching blocks or no blocks available.');
  //   });
  // }

  // ---------- Download Report ----------
  downloadBlockWiseReport(): void {
    if (this.blockWiseReportForm.invalid) {
      this.markFormGroupTouched(this.blockWiseReportForm);
      return;
    }

    const userIdStr = sessionStorage.getItem('userId');
    if (!userIdStr || isNaN(Number(userIdStr))) {
      this.showError('Session expired. Please login again.');
      return;
    }

    this.isDownloading = true;

    const formData = this.blockWiseReportForm.value;
    const branchId = formData.Branch || '0';
    const subjectId = this.primarySubjectId;
    const headId = this.primarySubjectHeadId;

    const payload1 = {
      Session: formData.SessionId,
      CoCode: formData.course,
      CgCode: formData.college,
      EmId: formData.Exam,
      SubjectId: subjectId,
      SubEsId: headId,
      BlockCode: formData.block
    };

    let jsonString = JSON.stringify(payload1);
    let filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 6,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": subjectId || 0,
      "SubEsId": headId || 0,
      "CsNo": '',
      "PgBreak": '',
      "StrId": branchId || '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": payload1.Session,
      "Extra1": jsonString,
      "Mode": true
    };

    this.umsService.setData(JSON.stringify(filter));
    this.router.navigate(['hbsreports']);

    setTimeout(() => {
      this.isDownloading = false;
    }, 1000);
  }

  saveAbsentCopyCase(): void {
    if (this.isFinalized) {
      this.showAlert('Records are already finalized. Save is disabled.');
      return;
    }

    if (this.blockWiseReportForm.invalid) {
      this.markFormGroupTouched(this.blockWiseReportForm);
      this.showError('Please fill all required fields.');
      return;
    }

    const formData = this.blockWiseReportForm.value;
    const totalAbsent = Number(formData.totalAbsent) || 0;
    const totalCopyCase = Number(formData.totalCopyCase) || 0;
    const headId = this.primarySubjectHeadId;

    if (!headId) {
      this.showError('Please select Subject Head.');
      return;
    }

    if (this.absentSeats.length !== totalAbsent || this.copyCaseSeats.length !== totalCopyCase) {
      this.showError('Please select all seat numbers.');
      return;
    }

    const absentRollNos: number[] = this.absentSeats.value
      .map((v: any) => Number(v))
      .filter((v: number) => !isNaN(v) && v > 0);

    const copyCaseRollNos: number[] = this.copyCaseSeats.value
      .map((v: any) => Number(v))
      .filter((v: number) => !isNaN(v) && v > 0);

    if (absentRollNos.length !== totalAbsent) {
      this.showError('Please select all Absent seat numbers.');
      return;
    }
    if (copyCaseRollNos.length !== totalCopyCase) {
      this.showError('Please select all CopyCase seat numbers.');
      return;
    }

    if (absentRollNos.length === 0 && copyCaseRollNos.length === 0) {
      this.showAlert('Absent and CopyCase are both 0.');
      return;
    }

    const loggedInUserId = parseInt(sessionStorage.getItem('userId') || '0') || 0;

    const basePayload = {
      SnNo: formData.SessionId,
      EmId: formData.Exam,
      CoCode: formData.course,
      EsId: headId,
      Cent: formData.college,
      CgCode: '',
      StrId: formData.Branch || 0,
      UserId: loggedInUserId
    };

    console.log('Bulk update base payload:', basePayload);
    console.log('Absent RollNos:', absentRollNos);
    console.log('CopyCase RollNos:', copyCaseRollNos);

    this.spinner.show();

    const calls: Promise<any>[] = [];

    if (absentRollNos.length > 0) {
      calls.push(this.callBulkStatusUpdate({
        ...basePayload,
        RollNos: absentRollNos,
        Status: 'AB'
      }));
    }

    if (copyCaseRollNos.length > 0) {
      calls.push(this.callBulkStatusUpdate({
        ...basePayload,
        RollNos: copyCaseRollNos,
        Status: 'CC'
      }));
    }

    const settledCalls = calls.map(p =>
      p.then(
        (value: any) => ({ status: 'fulfilled', value }),
        (reason: any) => ({ status: 'rejected', reason })
      )
    );

    Promise.all(settledCalls).then((results: any[]) => {
      this.spinner.hide();

      const failed: string[] = [];
      const success: string[] = [];

      results.forEach((r: any, index: number) => {
        let label = 'Absent';
        if (absentRollNos.length === 0) {
          label = 'CopyCase';
        } else if (copyCaseRollNos.length > 0 && index === 1) {
          label = 'CopyCase';
        }

        if (r.status === 'fulfilled' && r.value && r.value.status === true) {
          success.push(label);
        } else {
          const innerMsg = Array.isArray(r.value?.data) && r.value.data.length > 0
            ? r.value.data[0]?.Message
            : '';
          const msg = innerMsg
            || r.value?.message
            || r.reason?.error?.message
            || r.reason?.message
            || `Failed to update ${label}`;
          failed.push(`${label}: ${msg}`);
        }
      });

      const refreshGrid = () => {
        this.resetTotalsAndSeats();
        this.fetchStudents(false);
      };

      if (failed.length === 0) {
        this.showAlert(
          success.length > 1
            ? 'Absent and CopyCase updated successfully.'
            : `${success[0]} updated successfully.`
        );
        refreshGrid();
      } else if (success.length > 0) {
        this.showError(`Partial success — ${failed.join(' | ')}`);
        refreshGrid();
      } else {
        this.showError(failed.join(' | '));
      }
    });
  }

  submitFinal(): void {
    if (this.isFinalized) {
      this.showAlert('Records are already finalized.');
      return;
    }

    const formData = this.blockWiseReportForm.value;
    const headId = this.primarySubjectHeadId;

    if (!formData.SessionId || !formData.course || !formData.Exam || !headId) {
      this.showError('Please select Session, Course, Exam, Subject and Subject Head.');
      return;
    }

    const data: any = {
      message: 'Are you sure you want to Submit Final? Once finalized, Absent/CopyCase cannot be changed.',
      title: 'Alert',
      icon: 'fa fa-question',
    };

    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(
      ConformationModelComponent,
      data
    );

    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {

        const loggedInUserId = parseInt(sessionStorage.getItem('userId') || '0') || 0;

        const payload = {
          SnNo: formData.SessionId,
          CoCode: formData.course,
          EmId: formData.Exam,
          EsId: headId,
          Cent: formData.college,
          CgCode: '',
          StrId: formData.Branch || 0,
          UserId: loggedInUserId
        };

        console.log('Finalize payload:', payload);

        this.spinner.show();
        this.isFinalizing = true;

        this.umsService.finalizeStuExamAttend(payload).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.isFinalizing = false;

            if (res && res.status === true) {
              this.isFinalized = true;
              this.showAlert('Records finalized successfully.');
              this.fetchStudents(false);
            } else {
              const innerMsg = Array.isArray(res?.data) && res.data.length > 0
                ? res.data[0]?.Message
                : '';
              const msg = innerMsg
                || res?.message
                || 'Failed to finalize records.';
              this.showError(msg);
            }
          },
          (error: HttpErrorResponse) => {
            this.spinner.hide();
            this.isFinalizing = false;
            this.showError(error?.error?.message || 'Error finalizing records.');
          }
        );
      }
    });
  }

  private callBulkStatusUpdate(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.umsService.updateStuExamAttendStatusBulk(payload).subscribe(
        (res: any) => resolve(res),
        (err: any) => reject(err)
      );
    });
  }

  private updateDownloadButtonVisibility(): void {
    const formValues = this.blockWiseReportForm.value;
    this.showDownloadButton =
      formValues.SessionId &&
      formValues.course &&
      formValues.college &&
      formValues.Exam;
  }

  private resetDependentFields(fieldsToReset: string[]): void {
    fieldsToReset.forEach(field => {
      if (field === 'SelectedSubject' || field === 'SelectedSubjectHead') {
        this.blockWiseReportForm.get(field)?.setValue(null);
      } else {
        this.blockWiseReportForm.get(field)?.setValue('');
      }

      switch (field) {
        case 'course':
          this.CourseList = [];
          this.filteredCourseList = [];
          break;
        case 'college':
          this.CollegeList = [];
          this.filteredCollegeList = [];
          break;
        case 'Exam':
          this.ExamAList = [];
          this.filteredExamAList = [];
          this.isBranch = false;
          break;
        case 'Branch':
          this.BranchList = [];
          this.filteredBranchList = [];
          break;
        case 'SelectedSubject':
        case 'SelectedSubjectHead':
          break;
        case 'block':
          this.blocks = [];
          this.filteredBlocks = [];
          break;
      }
    });
    this.updateDownloadButtonVisibility();
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  private showError(message: string): void {
    const data = { message, title: 'Error', icon: 'fas fa-exclamation-circle' };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  private showAlert(message: string): void {
    const data = { message, title: 'Information', icon: 'fas fa-info-circle' };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }
}